import { Link } from 'react-router-dom';
import { LogIn } from 'lucide-react';

export const LoadBoardHero = ({ email, setEmail, otr, setOtr, drayage, setDrayage, subscribing, onSubscribe }) => (
  <section className="bg-zinc-900 py-14">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Left: Title + Dispatcher Login */}
        <div className="text-center lg:text-left">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Live Load Board
          </h1>
          <p className="text-zinc-400 mt-3 max-w-md mx-auto lg:mx-0">
            Browse available loads below. Subscribe to get notified instantly when new loads are posted.
          </p>
          <Link
            to="/login"
            className="inline-flex items-center gap-2 text-zinc-400 hover:text-white mt-5 text-sm font-medium transition-colors"
            data-testid="loadboard-dispatcher-login"
          >
            <LogIn className="w-4 h-4" />
            Dispatcher Login
          </Link>
        </div>

        {/* Right: Subscribe Form */}
        <div className="bg-zinc-800/50 border border-zinc-700/50 p-6">
          <h2 className="text-white font-bold text-lg mb-4">Get Load Notifications</h2>
          <form onSubmit={onSubscribe} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your email address"
              required
              className="w-full px-4 py-3 bg-zinc-800 border border-zinc-600 text-white placeholder-zinc-500 focus:border-red-500 outline-none text-sm"
              data-testid="load-alert-email"
            />
            <div className="flex gap-6">
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={otr}
                  onChange={(e) => setOtr(e.target.checked)}
                  className="w-4 h-4 accent-red-600"
                  data-testid="load-alert-otr"
                />
                <span className="text-sm text-zinc-300">OTR Loads</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={drayage}
                  onChange={(e) => setDrayage(e.target.checked)}
                  className="w-4 h-4 accent-red-600"
                  data-testid="load-alert-drayage"
                />
                <span className="text-sm text-zinc-300">Drayage Loads</span>
              </label>
            </div>
            <button
              type="submit"
              disabled={subscribing || (!otr && !drayage)}
              className="w-full bg-red-600 hover:bg-red-700 text-white py-3 font-bold uppercase tracking-wide text-sm transition-colors disabled:opacity-50"
              data-testid="load-alert-submit"
            >
              {subscribing ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
        </div>
      </div>
    </div>
  </section>
);
